export var MapServiceEvent = ['mapload', 'mapchange', 'mapAfterFrameChange'];

/**
 * 地图初始化配置项
 */

/**
 * 地图相机参数
 * @see
 */